import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { SortOption } from '@/utils/sortingUtils';

interface SortSelectorProps {
  value: SortOption;
  onChange: (value: SortOption) => void;
}

const SortSelector = ({ value, onChange }: SortSelectorProps) => {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-600 whitespace-nowrap">Trier par</span>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="w-[200px] border-gray-200 bg-white">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="distance">Le plus proche de moi</SelectItem>
          <SelectItem value="price">Prix (croissant)</SelectItem>
          <SelectItem value="rating">Le mieux noté</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};

export default SortSelector;

